
interface QueryBuilderOptions {
  tagTitle: string;
  hasIcon: boolean;
  hasMedia: boolean;
  hasDescription: boolean;
}

export function buildTagSummarizationQuery(options: QueryBuilderOptions): string {
  const { tagTitle, hasIcon, hasMedia, hasDescription } = options;

  const queryParts: string[] = [];

  queryParts.push('Summarize the following information');

  const instructions: string[] = [];

  if (hasIcon) {
    instructions.push('analyze the icon');
  }

  if (hasMedia) {
    instructions.push('describe the media (max 3 sentences)');
  }

  if (hasDescription) {
    instructions.push('summarize the text content');
  }

  if (instructions.length > 0) {
    queryParts.push(': ' + instructions.join(', '));
  }

  queryParts.push('. Make it human-readable and ensure all aspects of the tag (title, description, and media) are covered in the summary.');

  return queryParts.join('');
}

export function buildDisplayText(tagTitle: string): string {
  return `Summarization of tag ${tagTitle}`;
}

